'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

require('./EntityScope.scss');

var _constants = require('../../../../constants');

var _helpers = require('../../../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var Option = _antd.Select.Option;

var SHOW_CHILD = _antd.TreeSelect.SHOW_CHILD;

var EntityScope = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EntityScope, _Component);

  function EntityScope(props) {
    (0, _classCallCheck3.default)(this, EntityScope);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EntityScope.__proto__ || (0, _getPrototypeOf2.default)(EntityScope)).call(this, props));

    _initialiseProps.call(_this);

    _this.initializeForm();
    return _this;
  }

  (0, _createClass3.default)(EntityScope, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scopeEntityType !== this.props.scopeEntityType || prevProps.selectedEntityIds !== this.props.selectedEntityIds || prevProps.aggregationLevel !== this.props.aggregationLevel) {
        this.initializeForm();
      }

      if (this.props.submitEntityScopeForm !== prevProps.submitEntityScopeForm && this.props.submitEntityScopeForm === true) {
        this.checkValidation();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$form = this.props.form,
          getFieldDecorator = _props$form.getFieldDecorator,
          getFieldValue = _props$form.getFieldValue;
      var _props = this.props,
          currentAdvertiser = _props.currentAdvertiser,
          entityHierarchy = _props.entityHierarchy;


      var entityHierarchyLoading = entityHierarchy.loading ? { hasFeedback: true, validateStatus: "validating", disabled: true } : {};

      var aggregationLevelValue = getFieldValue('aggregationLevel');
      var scopeEntityTypeValue = getFieldValue('scopeEntityType');
      var selectedEntityIdsValue = getFieldValue('selectedEntityIds');

      var hideSelectedEntityIdsValue = scopeEntityTypeValue && scopeEntityTypeValue === "FB_ADVERTISER";
      var selectedEntityMessage = (0, _helpers.generateEntitySelectedMsg)(aggregationLevelValue, scopeEntityTypeValue, selectedEntityIdsValue, currentAdvertiser.name);
      var aggregationLevelOptions = _constants.AGGREGATION_LEVELS.map(function (entity) {
        return _react2.default.createElement(
          Option,
          { key: entity.value, value: entity.value },
          entity.label
        );
      });
      return _react2.default.createElement(
        'div',
        { className: 'entityScope__component' },
        _react2.default.createElement(
          _antd.Form,
          { layout: 'inline', hideRequiredMark: true },
          _react2.default.createElement(
            _antd.Row,
            null,
            _react2.default.createElement(
              FormItem,
              {
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.aggregationLevelLabel', defaultMessage: 'Apply rule to' }),
                colon: false
              },
              getFieldDecorator('aggregationLevel', {
                rules: [{ required: true, message: 'Missing aggregation level' }],
                validateTrigger: 'onChange'
              })(_react2.default.createElement(
                _antd.Select,
                {
                  showSearch: false,
                  style: { width: 150 },
                  placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.aggregationLevelPlaceholder', defaultMessage: 'Select an entity level' }),
                  onChange: this.onAggregationLevelChange
                },
                aggregationLevelOptions
              ))
            ),
            _react2.default.createElement(
              FormItem,
              {
                label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.entityScopeLabel', defaultMessage: 'within' }),
                colon: false
              },
              getFieldDecorator('scopeEntityType', {
                rules: [{ required: true, message: 'Missing entity scope' }],
                validateTrigger: 'onChange'
              })(_react2.default.createElement(
                _antd.Select,
                {
                  showSearch: false,
                  style: { width: 150 },
                  notFoundContent: 'Entity level required',
                  placeholder: 'Select an entity scope',
                  onChange: this.onScopeEntityTypeChange
                },
                aggregationLevelValue && this.renderEntityScopeOptions(aggregationLevelValue, scopeEntityTypeValue)
              ))
            )
          ),
          _react2.default.createElement(
            _antd.Row,
            { className: '' + (hideSelectedEntityIdsValue ? 'hide' : '') },
            _react2.default.createElement(
              _antd.Col,
              { span: 24 },
              _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({
                  label: 'Select entities',
                  colon: false
                }, entityHierarchyLoading),
                getFieldDecorator('selectedEntityIds', {
                  rules: [{
                    required: true,
                    message: 'Missing entities'
                  }],
                  validateTrigger: 'onSelect'
                })(_react2.default.createElement(_antd.TreeSelect, {
                  treeData: this.getTreeData(scopeEntityTypeValue),
                  showCheckedStrategy: SHOW_CHILD,
                  disabled: entityHierarchyLoading.disabled,
                  multiple: true,
                  treeCheckable: true,
                  filterTreeNode: function filterTreeNode(input, option) {
                    return option.props.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  },
                  treeNodeFilterProp: 'label',
                  placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'entityScope.modal.selectEntityPlaceholder', defaultMessage: 'Search Campaigns/Ad Sets' }),
                  style: { width: 867 },
                  dropdownStyle: { maxHeight: 400 },
                  allowClear: true,
                  onChange: this.onSelectedEntityIdsChange,
                  getPopupContainer: function getPopupContainer() {
                    return document.getElementsByClassName('entityScope__component')[0];
                  }
                }))
              )
            )
          )
        ),
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            'div',
            { className: 'entity-scope-message' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'entityScope.modal.selectedEntityMessage',
              defaultMessage: 'This Rule applies to: {selectedEntityMessage}',
              values: { selectedEntityMessage: selectedEntityMessage }
            })
          )
        )
      );
    }
  }]);
  return EntityScope;
}(_react.Component), _class.propTypes = {
  entityHierarchy: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired,
      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string.isRequired,
          label: _propTypes2.default.string.isRequired
        }))
      }))
    })).isRequired,
    loading: _propTypes2.default.bool.isRequired
  }).isRequired,
  submitEntityScopeForm: _propTypes2.default.bool.isRequired,
  onEntityScopeFormSubmit: _propTypes2.default.func.isRequired,
  currentAdvertiser: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  form: _propTypes2.default.shape({
    getFieldValue: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired,
    setFieldsValue: _propTypes2.default.func.isRequired,
    setFieldsInitialValue: _propTypes2.default.func.isRequired,
    isFieldsTouched: _propTypes2.default.func.isRequired,
    validateFields: _propTypes2.default.func.isRequired
  }).isRequired,
  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
    return entityScope.value;
  })),
  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
  aggregationLevel: _propTypes2.default.oneOf(_constants.AGGREGATION_LEVELS.map(function (aggregationLevel) {
    return aggregationLevel.value;
  }))
}, _class.defaultProps = {
  scopeEntityType: null,
  selectedEntityIds: null,
  aggregationLevel: null
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getTreeData = function (scopeEntityType) {
    var entityHierarchy = _this2.props.entityHierarchy;

    var filteredHierarchy = void 0;
    if (scopeEntityType === 'FB_CAMPAIGN') {
      filteredHierarchy = entityHierarchy.data.map(function (campaign) {
        return (0, _extends3.default)({}, campaign, { children: [] });
      });
      return filteredHierarchy;
    } else if (scopeEntityType === 'FB_ADSET') {
      filteredHierarchy = entityHierarchy.data.filter(function (campaign) {
        return campaign.children.length;
      }).map(function (campaign) {
        var adsets = campaign.children.map(function (adset) {
          return (0, _extends3.default)({}, adset, { children: [] });
        });
        return (0, _extends3.default)({}, campaign, { children: adsets });
      });
      return filteredHierarchy;
    }
    filteredHierarchy = entityHierarchy.data.map(function (campaign) {
      var adsets = campaign.children.filter(function (adset) {
        return adset.children.length;
      });
      return (0, _extends3.default)({}, campaign, { children: adsets });
    }).filter(function (campaign) {
      return campaign.children.length;
    });
    return filteredHierarchy;
  };

  this.renderEntityScopeOptions = function (aggregationLevel, entityScope) {
    return _constants.ENTITY_SCOPE.map(function (entityScope) {
      if ((0, _helpers.isEntityScopeValid)(aggregationLevel, entityScope.value)) {
        return _react2.default.createElement(
          Option,
          { key: entityScope.value, value: entityScope.value },
          entityScope.label
        );
      }
      return [];
    });
  };

  this.onAggregationLevelChange = function (aggregationLevel) {
    var _props$form2 = _this2.props.form,
        getFieldValue = _props$form2.getFieldValue,
        setFieldsValue = _props$form2.setFieldsValue;

    if (!(0, _helpers.isEntityScopeValid)(aggregationLevel, getFieldValue('scopeEntityType'))) {
      setFieldsValue({
        scopeEntityType: null,
        selectedEntityIds: []
      });
    }

    _this2.setState({
      aggregationLevel: aggregationLevel,
      scopeEntityType: getFieldValue('scopeEntityType'),
      selectedEntityIds: getFieldValue('selectedEntityIds')
    });
  };

  this.onScopeEntityTypeChange = function (value) {
    var currentAdvertiser = _this2.props.currentAdvertiser;
    var setFieldsValue = _this2.props.form.setFieldsValue;


    var newSelectedEntityIdsValue = [];

    if (value === 'FB_ADVERTISER') {
      newSelectedEntityIdsValue.push(currentAdvertiser.id.toString());
    }

    setFieldsValue({
      selectedEntityIds: newSelectedEntityIdsValue
    });

    /**
     * We set the evaluated value of the state.selectedEntityIds rather than the
     * actual form field value to ensure no race conditions happen and throw
     * both things out of sync.
     */
    _this2.setState({ scopeEntityType: value, selectedEntityIds: newSelectedEntityIdsValue });
  };

  this.onSelectedEntityIdsChange = function (value) {
    var getFieldValue = _this2.props.form.getFieldValue;

    _this2.setState({ selectedEntityIds: value, scopeEntityType: getFieldValue('scopeEntityType') });
  };

  this.initializeForm = function () {
    var props = _this2.props;
    var _props$form3 = props.form,
        setFieldsInitialValue = _props$form3.setFieldsInitialValue,
        getFieldDecorator = _props$form3.getFieldDecorator;

    getFieldDecorator('aggregationLevel');
    getFieldDecorator('scopeEntityType');
    getFieldDecorator('selectedEntityIds');
    setFieldsInitialValue({
      aggregationLevel: props.aggregationLevel,
      scopeEntityType: props.scopeEntityType,
      selectedEntityIds: props.selectedEntityIds
    });
  };

  this.checkValidation = function () {
    _this2.props.form.validateFields(function (error, value) {
      if (error) {
        _this2.props.onEntityScopeFormSubmit(_this2.state, false);
      } else {
        _this2.props.onEntityScopeFormSubmit(_this2.state, true);
      }
    }, {
      force: true
    });
  };
}, _temp);
exports.default = _antd.Form.create({})(EntityScope);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/EntityScope.js
// module id = 3770
// module chunks = 4